import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

function WishlistPage() {
  const { translate } = useLanguage();
  return <main className="commerce-page"><div className="container commerce-empty"><p className="eyebrow">{translate('Saved products')}</p><h1>{translate('Your Wishlist')}</h1><p>{translate('Wishlist saving is optional and no products have been saved on this device.')}</p><Link className="button button--primary" to="/shop">{translate('Browse products')}</Link></div></main>;
}
export default WishlistPage;
